/**
 * Render the version line at the bottom of the Account footer. Hub
 * bakes its own version into the bundle at build time; the Gateway
 * version flows in over the shared `/api/gateway/status` shell state.
 * When Gateway is offline — or older builds that predate the field —
 * we fall back to Hub-only so the footer never reads `vundefined`.
 */
export function formatVersionFooter(input: {
  hubVersion: string;
  gatewayVersion?: string | undefined;
  gatewayOnline: boolean;
}): string {
  const hub = `Hub v${input.hubVersion}`;
  if (!input.gatewayOnline || !input.gatewayVersion) return hub;
  return `${hub} · Gateway v${input.gatewayVersion}`;
}
